import React, { useMemo, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormSelect from '../../components/FormSelect';
import { object, string, arrayOf, any, func, bool } from 'prop-types';
import { Translation } from 'react-i18next';
import ErrorMsg from '../../../scenes/components/ErrorMsg';

const styles = theme => ({
  component: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  barLayout: {
    padding: theme.spacing(1),
  },
});

const Component = ({
  classes,
  visaType,
  config,
  application,
  visaPurpose,
  nationality,
  diplomaticMission,
  visaTypes,
  visaPurposes,
  nationalities,
  visaTypeChanged,
  visaPurposeChanged,
  nationalityChanged,
  readOnly = false,
  isVisaTypeRequired,
  isNationalityRequired,
  isVisaPurposeRequired,
  visaTypeError,
  nationalityError,
  visaPurposeError,
  diplomaticMissions,
  diplomaticMissionChanged,
  isDiplomaticMissionRequired,
  diplomaticMissionReset,
  diplomaticMissionError,
  error,
}) => {
  useEffect(() => {
    if (!nationality && visaPurpose) {
      visaPurposeChanged(null);
    }
    if (!visaPurpose && visaType) {
      visaTypeChanged(null);
    }
  }, [nationality, visaPurpose, visaType]);

  return (
    <Translation>
      {t => {
        const isDiplomaticMission = useMemo(() => {
          const visaTypeSelected =
            config &&
            config.visaTypes.find(i => i.uuid === application.visatypeId);
          if (
            visaTypeSelected &&
            visaTypeSelected.visaTypeConfig &&
            visaTypeSelected.visaTypeConfig.isDiplomaticMission
          )
            return visaTypeSelected.visaTypeConfig.isDiplomaticMission;
          else diplomaticMissionReset();
        }, [application.visatypeId, config]);
        return (
          <div>
            {!!error && <ErrorMsg error={error} />}
            <Typography
              className={classes.barLayout}
              style={{ color: '#ffffff', background: '#4CAF50' }}
              variant="subtitle1"
              align="left"
              gutterBottom
            >
              {t('visaDetails')}
            </Typography>
            <Grid container spacing={3} key="form-grid-container">
              <Grid item xs={6}>
                <FormSelect
                  className={classes.component}
                  id="nationality"
                  label={t('nationality')}
                  value={nationality}
                  options={nationalities}
                  onChange={nationalityChanged}
                  readOnly={readOnly}
                  required={isNationalityRequired}
                  error={nationalityError}
                />
              </Grid>
              <Grid item xs={6}>
                <FormSelect
                  className={classes.component}
                  id="visa-purpose"
                  label={t('visaPurpose')}
                  value={visaPurpose}
                  options={visaPurposes}
                  onChange={visaPurposeChanged}
                  readOnly={readOnly || !nationality}
                  required={isVisaPurposeRequired}
                  error={visaPurposeError}
                />
              </Grid>
              <Grid item xs={6}>
                <FormSelect
                  className={classes.component}
                  id="visa-type"
                  label={t('visaType')}
                  value={visaType}
                  options={visaTypes}
                  onChange={visaTypeChanged}
                  readOnly={readOnly || !visaPurpose}
                  required={isVisaTypeRequired}
                  error={visaTypeError}
                />
              </Grid>
              {isDiplomaticMission && (
                <Grid item xs={6}>
                  <FormSelect
                    className={classes.component}
                    id="diplomaticMission"
                    label={t('diplomaticMission')}
                    value={diplomaticMission}
                    options={diplomaticMissions}
                    onChange={diplomaticMissionChanged}
                    readOnly={readOnly}
                    required={isDiplomaticMissionRequired}
                    error={diplomaticMissionError}
                  />
                </Grid>
              )}
            </Grid>
          </div>
        );
      }}
    </Translation>
  );
};

Component.propTypes = {
  classes: object.isRequired,
  visaType: string,
  isVisaTypeRequired: bool,
  visaTypeError: string,
  visaPurpose: string,
  isVisaPurposeRequired: bool,
  visaPurposeError: string,
  nationality: string,
  isNationalityRequired: bool,
  nationalityError: string,
  visaTypes: arrayOf(any),
  visaPurposes: arrayOf(any),
  nationalities: arrayOf(any),
  visaTypeChanged: func.isRequired,
  visaPurposeChanged: func.isRequired,
  nationalityChanged: func.isRequired,
  readOnly: bool,
};

Component.defaultProps = {
  visaTypes: [],
  visaPurposes: [],
  nationalities: [],
};

export default withStyles(styles)(Component);



// WEBPACK FOOTER //
// ./src/view/forms/Application/VisaDetails/VisaDetailsComponent.js